<template>    
  <div class="row pb-3" :key="velues">    
      <h2 class="form-title">{{ getFormSelecionado.titulo }}</h2>
<!-- {{ this.$props.value }} -->
      <!--{{ this.parametrosPage }} -->
      <div :class="`${getFormSelecionado.col || 'col-xs-12'}`">
        <div class="row">
          <template v-for="(listaDeCampos) in getFormSelecionado.corpo">
            <input 
              v-if="
                !ignorarHidden && 
                (listaDeCampos.hidden === true || listaDeCampos.hidden === 'true') && 
                !shouldKeepFieldVisible(listaDeCampos) &&
                (!isFieldRequired(listaDeCampos.validation) || isFieldFilled(listaDeCampos.name))
              "
              type="hidden"
              :name="listaDeCampos.name"
              :key="`hidden-${listaDeCampos.id || listaDeCampos.name}`"
              v-model="values[listaDeCampos.name]"
            />

            <TexInputComponent
              v-if="
                (listaDeCampos.type == 'text' ||
                listaDeCampos.type == 'textarea') &&
                verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :readonly="(listaDeCampos?.readonly) ? listaDeCampos.readonly : false"
              :validation="listaDeCampos.validation"
              :placeholder="listaDeCampos.placeholder"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              :mask="listaDeCampos.mask"
              @update="inputCallback"              
            />

            <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select' &&
                verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            ></ComboboxInputComponent>

            <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select-avancado' &&
                verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options[retornaValorEnderecamento(listaDeCampos.nome_enderecamento)]"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            ></ComboboxInputComponent>

            <RadioInputComponent
              v-else-if="listaDeCampos.type == 'radio' && 
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :name="listaDeCampos.name"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :validation="listaDeCampos.validation"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            >
            </RadioInputComponent>

            <DateInputComponent
              v-else-if="
                (listaDeCampos.type == 'date' ||
                listaDeCampos.type == 'time' ||
                listaDeCampos.type == 'datetime-local') &&
                verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :validation="listaDeCampos.validation"
              :placeholder="listaDeCampos.placeholder"
              :class="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            />

            <TextXhrSelectComponent 
              v-else-if="(listaDeCampos.type == 'text-xhr-select') && 
                verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :key="listaDeCampos.id"
              :name="listaDeCampos.name"
              :label="listaDeCampos.label"              
              :placeholder="listaDeCampos.placeholder"
              :validation="listaDeCampos.validation"
              :classe="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :parameters="parametrosPage"
              :configInput="listaDeCampos"
              v-model="values[listaDeCampos.name]"
              @update="inputCallbackExtends"
            />

            <SelectXhrComponent 
              v-else-if="(listaDeCampos.type == 'select-xhr') 
                && verificadorCondicional(listaDeCampos.show) &&
                (
                  ignorarHidden ||
                  !listaDeCampos.hidden || 
                  shouldKeepFieldVisible(listaDeCampos) ||
                  (isFieldRequired(listaDeCampos.validation) && !isFieldFilled(listaDeCampos.name))
                )
              "
              :key="listaDeCampos.id"
              :name="listaDeCampos.name"
              :label="listaDeCampos.label"              
              :placeholder="listaDeCampos.placeholder"
              :validation="listaDeCampos.validation"
              :classe="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :parameters="parametrosPage"
              :configInput="listaDeCampos"
              v-model="values[listaDeCampos.name]"
              @update="inputCallbackExtends"
            />

            <TextMaskComponent
              v-if="(listaDeCampos.type == 'text-mask') && 
                verificadorCondicional(listaDeCampos.show)"
              :key="listaDeCampos.id"
              :name="listaDeCampos.name"
              :label="listaDeCampos.label"              
              :placeholder="listaDeCampos.placeholder"
              :validation="listaDeCampos.validation"
              :classe="[listaDeCampos.col, campoObrigatorio(listaDeCampos.validation)]"
              :parameters="parametrosPage"
              :configInput="listaDeCampos"
              v-model="values[listaDeCampos.name]"
              @update="inputCallbackExtends"
            />
          </template>
        </div>

        <div class="col-md-6">
          <ButtonComponent v-if="exportarDados" type="button" @salvarFormularioDinamico="exibeValue()" label="Salvar" />
        </div>
      </div>
    <SGPLoadingComponent v-if="loadingFormularios" />
  </div>
</template>

<script>
import Vue from 'vue';
import VueMask from 'v-mask';
import '@/assets/css/formulate.css';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VueFormulate from '@braid/vue-formulate';
import { pt } from '@braid/vue-formulate-i18n';
import ButtonComponent from './ButtonComponent.vue';
import TexInputComponent from './TexInputComponent.vue';
import RadioInputComponent from './RadioInputComponent.vue';
import ComboboxInputComponent from './ComboboxInputComponent.vue';
import DateInputComponent from './DateInputComponent.vue';
import TextXhrSelectComponent from './TextXhrSelectComponent.vue';
import SelectXhrComponent from './SelectXhrComponent.vue';
import TextMaskComponent from './TextMaskComponent.vue';

import HttpClient from '@/common/boot/HttpClient'


Vue.use(VueFormulate, VueMask, {
  classes: {
    inputHasErrors: 'is-invalid',
    errors: 'list-unstyled text-danger',
  },
  locale: 'pt',
  plugins: [pt],
});

export default {
  components: {
    RadioInputComponent,
    ButtonComponent,
    TexInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    TextXhrSelectComponent,
    SelectXhrComponent,
    TextMaskComponent
  },

  name: 'RenderizaFormModosComponent',

  props: {
    formulario_id: {
      type: Number,
      required: true
    },

    acaoFormulario: {
      type: String,
      required: false,
      default: 'cadastrar'
    },

    endpoint: {
      type: String,
      required: false,
      default: () => ''
    },

    exportarDados: {
      type: Boolean,
      required: false,
      default: false
    },

    emitirDados: {
      type: Boolean,
      required: false,
      default() {
        return  this.$options.propsData.exportarDados
      }
    },

    forms: {
       type: Array,
       required: false       
    },

    formValues: {
      type: Object,
      required: true,
    },

    jsonFormulario: {
      type: [Object, Boolean],
      required: false,
      default: false
    },

    value: {
      type: Object,
      required: false
    },

    ignorarHidden: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
      values: {
        formValidation: false
      },
      gatilhos: [],
      form: {},
      validation: [],  
      initiallyRenderedRequiredFields: []    
    }
  },

  async created() {
    await this.formSelecionado()
    await this.setarVariaveisDoFormulario()
    this.initializeRequiredFields()
  },

  computed: {
    ...mapGetters('formularios', ['formularioSelecionado', 'loadingFormularios']),

    getFormSelecionado() {
        return this.form
    },
    
    parametrosPage () {
      return this.value
    }
  },

  methods: {
    ...mapActions('formularios', ['renderizarFormulario', 'inserirOptions', 'salvarDadosFormulario']),
    ...mapMutations('formularios', ['INSERIR_FORM_VALUES']),

    isFieldFilled(fieldName) {
      if (!(fieldName in this.values)) return false;
      
      const value = this.values[fieldName];
      
      if (value === null || value === undefined) return false;
      if (value === '') return false;
      if (Array.isArray(value) && value.length === 0) return false;
      
      return true;
    },

    isFieldRequired(val) {
      if (typeof val === 'undefined') return false      
      return val.includes('required')
    },

    initializeRequiredFields() {
      if (!this.getFormSelecionado?.corpo) return;
      
      this.getFormSelecionado.corpo.forEach(campo => {
        if ((campo.hidden === true || campo.hidden === 'true') && 
            this.isFieldRequired(campo.validation) && 
            !this.isFieldFilled(campo.name)) {
          this.initiallyRenderedRequiredFields.push(campo.name);
        }
      });
    },

    shouldKeepFieldVisible(campo) {
      return this.initiallyRenderedRequiredFields.includes(campo.name);
    },

    campoObrigatorio(val) {
      if(this.isFieldRequired(val)) {
        return 'input_obrigatorio'
      }
      return 
    },

    async formSelecionado() {
        let objForm = this.$props.forms.filter(form => form.id == this.$props.formulario_id)[0];
        if(typeof objForm != 'undefined') {
            this.form = objForm
        }       
    },

    async setarVariaveisDoFormulario () {
      const corpoForm = this.getFormSelecionado.corpo
      if (typeof corpoForm === 'undefined') return
      corpoForm.forEach(item => {
        this.validation.push({
          name: item.name,
          show: item.show,
          validation: item.validation 
        })

        this.$set(this.values, item.name, '')

        if(typeof this.$props.formValues == 'undefined') {
          this.$set(this.values, item.name, '')
          if (('default_value' in item)) {
            this.$set(this.values, item.name, item.default_value)
          }
        } else if (typeof this.$props.formValues[item.name] != 'undefined') {          
          this.$set(this.values, item.name, this.$props.formValues[item.name])          
        } 

        if (typeof this.values[item.name] != 'undefined') {
          if (('const_value' in item)) {
            this.$set(this.values, item.name, item.const_value)
          }
        }
      })

      return true;
    },

    inputCallback (val) {
      const valorCopiado = { ...this.values }

      valorCopiado[val.name] = val.model

      this.values = valorCopiado
    },

    inputCallbackExtends(val) {
      const valorCopiado = { ...this.values }

      if(Array.isArray(val)) {
        val.forEach(obj => {
          valorCopiado[obj.name] = obj.model
        })
      } else {
        valorCopiado[val.name] = val.model
      }

      this.values = valorCopiado
    },

    exibeValue () {
      if(this.exportarDados) {
        this.$emit('dadosFormularioDinamicoEmit', {
          values: this.values,
          config: this.getFormSelecionado
        });

        return
      }

      if(this.endpoint) {
        this.salvarDadosFormulario(this.values, this.endpoint)
      }
    },

    retornaValorEnderecamento (enderecamento) {
      /* O endereçamento representa e o vinculo com os campos que possibilita a captura do valor deles */
      if(Array.isArray(enderecamento)) {
        const valorEnderecamentos = enderecamento.map(nome => this.values[nome]).join('__');        
        return valorEnderecamentos
      }      
      if (enderecamento) {
        return this.values[enderecamento]
      } else {
        return ["Não existe valor disponível"]
      }
    },

    verificadorCondicional (val) {
      return eval(val)
    },

    apontarGatilhos () {
      this.getFormSelecionado.corpo.forEach(item => {
        if (item.requisicao) {
          if(!this.gatilhos.includes(item.requisicao.gatilho)) {
            this.gatilhos.push(item.requisicao.gatilho)
          }
        }
      })
    },

    fabricaDeRequisicoes (gatilho = 'load') {
      if (!this.getFormSelecionado?.corpo) {
        return
      }
      this.getFormSelecionado.corpo.forEach(item => {
        if (item.requisicao){

          if (item.requisicao.gatilho !== gatilho ) {            
            return 
          }
                   
          HttpClient({ method: item.requisicao.metodo, url: item.requisicao.endpoint}).then(response => {
            const itemOptions = [{
              label: 'Selecione',
              value: ''
            }]

            response.data.data.forEach(respItem => {
              const objOption = {
                label: respItem[item.requisicao.optionLabel],
                value: respItem[item.requisicao.optionValue]
              }
              
              itemOptions.push(objOption)
            })

            this.inserirOptions({ name: item.name, options: itemOptions})

          })
        }
      });
    },

    validationForm () {
      let inputValidation = true            
      this.validation.forEach(input => {
        if(eval(input.show) && input.validation && input.validation.includes('required')) {
          if(this.values[input.name] == null) {
            inputValidation = false
          } else if((typeof this.values[input.name] != 'undefined' && this.values[input.name] != null) && (this.values[input.name].length == 0 || this.values[input.name] == '-')) {            
            inputValidation = false
          }
        }
      })
      this.values.formValidation = inputValidation
    },

    replaceValues() {
      for(const [key,value] of Object.entries(this.value)) {
        if(Object.keys(this.values).includes(key)) {
          this.$set(this.values, key, value)
        }        
      }
    }
  },

  watch: {
    values (newValue, oldValue) {
      this.validationForm()
      for(const keyValue in newValue) {
        if(this.gatilhos.includes(keyValue)) {
          if(newValue[keyValue] !== oldValue[keyValue]) {
             this.fabricaDeRequisicoes(keyValue, newValue[keyValue])
          }
        }
      }

      this.apontarGatilhos();

      if(this.emitirDados) {
        this.$emit('dadosAoAtualizarFormularioEmit', { 
          values: newValue,
          config: this.getFormSelecionado
        });
      }
    },

    value () {      
      this.replaceValues()
    },
  }
};
</script>

<style scoped>

.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: 0.5em;
  max-width: 80%;
  box-sizing: border-box;
  margin: auto;
}

.form-title {
  margin-top: 0;
}

.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}

@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - 0.5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: 0.5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: 0.5em;
  }

  .mdn-Icon-claro {
    margin: auto;
  }
}
</style>

<style>
  .input_obrigatorio > div > label:first-of-type::after{
    content: '*' !important; /* Adiciona o asterisco */
    color: red !important ;   /* Define a cor do asterisco */
    margin-left: 4px !important; /* Espaço entre o texto do label e o asterisco */
  }
</style>